import styles from './dashboard.module.scss';
import Sidebar from 'components/Sidebar/sidebar';
import Header from 'components/Header/header';
import { useState } from 'react';

interface DashboardProps {
  children?: React.ReactNode;
}

const Dashboard: React.FC<DashboardProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={styles.dashboardContainer}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <div className={styles.mainWrapper}>
        <Header />

        <main className={styles.content}>
          {children || (
            <div className={styles.placeholder}>
              <h2>Welcome to Dgenta system</h2>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
